<template>
  <svg
    class="h-4 w-4"
    viewBox="-1 -1 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="#ff3366" stroke-width="4" fill="none" />

    <circle cx="8" cy="8" r="3" fill="none" stroke="hitwe" />
  </svg>
</template>

<script>
export default {
  name: "IconCircle",
};
</script>

<style scoped>
/* Optional scoped styles for IconCircle component */
</style>
